export default __webpack_public_path__ + "static/media/no-users.feca714e.svg";